export default __webpack_public_path__ + "static/skdDfyfFooterImage-a5c41c5a6d783e9489c0b0ffd5674856.png";